// World 5 (Helix) — the first paid-tier world. Five colours, wider geometry.
// Ships in two parts:
//   Part A (L1-L10): tools/generate-world5.mjs — d=5 opener → d=7 climax.
//   Part B (L11-L20): tools/generate-world5-b.mjs — bonus pack of d=6 puzzles
//     with harder branching/insight profiles. Plays as a "continuation" after
//     the main progression rather than a steeper climb (part A already peaks
//     the depth curve for the first paid world; saving d=7+ pressure for W6+).
import type { LevelDef } from '@tessera/engine';
import { WORLD_5_GENERATED } from './world5-generated';
import { WORLD_5B_GENERATED } from './world5b-generated';

export const WORLD_5_LEVELS: LevelDef[] = [...WORLD_5_GENERATED, ...WORLD_5B_GENERATED];
